var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.06885 4.82759H17.9309M9.99988 7.58621V15.1724M6.89643 7.58621L7.58609 15.1724M13.1033 7.58621L12.4137 15.1724M3.79299 4.82759H16.2068L15.024 16.6883C14.9901 17.0288 14.8309 17.3445 14.5773 17.5741C14.3237 17.8038 13.9938 17.931 13.6516 17.931H6.34816C6.006 17.931 5.67607 17.8038 5.42245 17.5741C5.16883 17.3445 5.00962 17.0288 4.97574 16.6883L3.79299 4.82759ZM13.1033 4.82759H6.89643V2.06897H13.1033V4.82759Z",
    stroke: "#FCFDFF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.b90d19806e3f28b074942192bec672fd.svg";
export { ForwardRef as ReactComponent };